<div class=" mt-4">
  <section class="my-4">
    <div class="scrollmenu">
      <a [routerLink]="['/pos/customer/manage']"> Customer </a>
      <a [routerLink]="['/pos/employee/manage']"> Employee </a>
      <a [routerLink]="['/pos/orders/manage']"> Orders </a>
      <a [routerLink]="['/pos/taxfee/manage']"> Tax-Fee </a>
      <a [routerLink]="['/pos/category/manage']"> Item-Category </a>
      <a [routerLink]="['/pos/item/manage']">Items </a>
      <a [routerLink]="['/pos/businesshour/manage']"> Business-Hours </a>
      <!-- <a [routerLink]="['/pos/ordertype/manage']"> Order-Type </a>
      <a routerLinkActive = "active" class="active menu" [routerLink]="['/pos/payment/manage']"> Payment </a>
      <a [routerLink]="['/pos/tips/manage']">Tips </a> -->
<!--  
            <a [routerLink]="['/pos/order/manage']"> <i class="fa-1x mr-1 icon-img fas fa-receipt"></i>  Order
            </a>
      -->
      <!--  
            <a [routerLink]="['/pos/orderreceipt/manage']"> <img class="mr-1 icon-img" src="assets/img/order-recpit-icon.png" alt="customer-icon"/>Order Receipt
            </a>
      -->

      <!-- <a [routerLink]="['settlementvendors/manage']"> <i class="fa-1x mr-1 icon-img fas fa-briefcase"></i> Settlement vendors
            </a> -->
      <!--   <a [routerLink]="['/pos/tender/manage']">     <i class="fa fa-shopping-cart" aria-hidden="true"></i>   Tender </a>
          -->

    </div>
  </section>
  <section>


    <div class="row mb-3">
      <div class="col-md-12">
        <div class="float-right">
          <button class="dash-btns btn mr-3" type="button" id="NewTransaction" [routerLink]="['/pos/payment/new']"
              matTooltip="New Sale Transaction"> New payment</button>

            <button class="dash-btns btn mr-3" type="button" id="cache" matTooltip="New Sale Transaction"
              (click)="clearcache()"> Clear Cache</button>

              <button class="dash-btns btn" type="button" id="filtering" (click)="filters()"  > <i class="fa fa-filter" aria-hidden="true"></i> Filter</button>
 

        </div>



      </div>
      <div class="col-md-12">
        <small class=" font-16 gary-t ">Currently we are displaying last 7 days report. For more details please click on
          Filter</small>
      </div>
    </div>





    <div class="row  my-4" *ngIf="filtering">
      <div class="col-md-12">
        <div class="card-1 p-4">
          <h4 class="font-26 gary-t">Filter Your Result</h4>
          <p>Please Fill the details to filter your result</p>
         
        <div class="col-md-12">
          <!-- filtering starts -->
          <form>

            <div class="row m-0">
  
              <div class="col-md-3 mt-3">
                
                 <div class="form-group">
                  <label class="customlabel"> Set Default PreAuth Amount</label>
                      <input class="formcontrol-user form-control"  type="PreAuthAmount" placeholder="Order Type" id="PreAuthAmount" [formControl]="PreAuthAmount">
                 
                 </div>
               </div>
               <div class="col-md-3 mt-3">
                
                 <div class="form-group">
                  <label class="customlabel">SignFor TranUnderAmount</label>
                      <input class="formcontrol-user form-control"  type="TranUnderAmount" placeholder="DontRequiredSignForTranUnderAmount" id="TranUnderAmount" [formControl]="TranUnderAmount">
                 
                 </div>
               </div>
               <div class="col-md-3 mt-3">
                
                 <div class="form-group">
                  <label class="customlabel"> Manager Approval RequiredForRefundAboveAmount</label>
                      <input class="formcontrol-user form-control"  type="RefundAboveAmount" placeholder="Manager Approval RequiredForRefundAboveAmount" id="RefundAboveAmount" [formControl]="RefundAboveAmount">
                 
                 </div>
               </div>
           
              <div class="col-md-3 mt-3">
                
                 <div class="form-group">
                  <label class="customlabel"> Date</label>
                  <div class="selectcustom mb-0">
                    <ngx-select [items]="Range" id="daterange" [formControl]="daterange" placeholder="Select"
                    (ngModelChange)="selectedaterange()" required>
                  </ngx-select>
                  </div>
                 
                 </div>
               </div>
               <div class="col-md-3 mt-3" *ngIf="Rfromdate">
                 
                 <div class="form-group">
                  <label class="customlabel">From Date</label>
                   <input class="formcontrol-user form-control"  type="date" placeholder="From Date" id="fromdate" [formControl]="fromdate"
                    (change)="checkDateRange()">
                 </div>
               </div>
 
               <div class="col-md-3 mt-3" *ngIf="Rfromdate">
                
                 <div class="form-group">
                  <label class="customlabel">To Date</label>
                   <input class="formcontrol-user form-control"  type="date" placeholder="To Date" id="todate" [formControl]="todate"
                     (change)="checkDateRange()">
                 </div>
               </div>
               <span class="text-danger" *ngIf="isStartDateGreaterthenEndDate">From Date Should not be greater than To Date</span>
            </div> 



          </form> 

          <!-- filtering ends -->
        </div>
        <div class="col-md-12 text-right">

          <div class="col text-right mt-3">
            <button class="dash-btns btn " type="button" id="filtering" (click)="search()"
            > Search</button> 
          </div>
        </div>
        </div>
      </div>

    </div>



 
    <div class="row">
      <div class="col-md-12 ">
        <ngx-datatable #table class='bootstrap no-detail-row'  [footerHeight]="50"
        [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="rows" >
        <ngx-datatable-column name="Action">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <a class=" edit"
              [routerLink]="['/pos/payment/view',{id : row.id,posSubscriptionId: row.posSubscriptionId}]"
              data-toggle="tooltip" data-placement="top" title="View">
              <img src="./assets/ViewDetails.svg">
            </a>
            <a class="edit px-2"
              [routerLink]="['/pos/payment/new',{id : row.id,posSubscriptionId: row.posSubscriptionId}]"
              data-toggle="tooltip" data-placement="top" title="Edit">
              <em class="fa-1x mr-2 fas fa-edit"></em>
            </a>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="SetDefaultPreAuthAmount">
          <ng-template let-row="row" ngx-datatable-cell-template> {{row.setDefaultPreAuthAmount}}
          </ng-template>

        </ngx-datatable-column>
        <ngx-datatable-column name="DontRequiredSignForTranUnderAmount" [width]="205">
          <ng-template let-row="row" ngx-datatable-cell-template> {{row.dontRequiredSignForTranUnderAmount}}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="ManagerApprovalRequiredForRefundAboveAmount" [width]="205">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.managerApprovalRequiredForRefundAboveAmount}}
          </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="SignatureOption" [width]="205">

          <ng-template let-row="row" ngx-datatable-cell-template> {{row.signatureOption}}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Date Time">
          <ng-template let-row="row" ngx-datatable-cell-template>{{row.updatedDateTime | date:'d/M/yy, h:mm a'}}
          </ng-template>
        </ngx-datatable-column>




      </ngx-datatable>
      </div>
    </div>
  </section>
</div>











<!-- <section  >
  <div class="block-header">
    <div class="">
      <div class="row ">
        <div class="col-md-12 p-0">
          <h2 class="poppins font-weight-bold ">Manage payment</h2>
        </div>
        <div class=" col-md-5 px-6 col-sm-12 p-0">

          <div class="breadcrumb flat">
            <a [routerLink]="['/pos']"> Home</a>
            <a class="active">Manage payment</a>
          </div>
        </div>
        <div class="col-md-7">
          <div class="float-right">

           

          </div>
        </div>

      </div>
    </div>

  </div>
  <div class="container  ">



    <div class="row">
      <div class="col-md-12 p-0">
        <div class=" card px-5 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
      
        </div>
      </div>
    </div>
  </div>
</section> -->








 